module.exports = __webpack_public_path__ + "static/img/3872_phase_function_Paper_Points.7cf5a49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3872_phase_function_Paper_Points.png
// module id = dHJ+
// module chunks = 0